module.exports = "<span gw-feature-toggler category=\"faq\">\n    <a href=\"#\" ui-sref=\"faq({ 'faqScrollTo': fragment })\">\n        <span ng-if=\"defaultContent\">{{ inlineContent | translate }}</span>\n        <span ng-transclude></span>\n    </a>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/faq/templates/faq-link.html
// module id = 348
// module chunks = 0